import { Link } from "react-router-dom";

import styled, { css } from "styled-components";

// Aparência do nome da entidade nas tabelas do admin: cor de destaque do tema,
// sublinhado apenas no hover — sinaliza o clique sem poluir tabelas densas.
const linkAppearance = css`
  font-weight: 500;
  text-decoration: none;

  &:hover,
  &:focus-visible {
    text-decoration: underline;
  }
`;

export const NameLink = styled(Link)`
  color: ${({ theme }) => theme.colors.primary.vividCerulean};
  ${linkAppearance}
`;

// Mesma aparência para o caso target="_blank" (aba "Pré-seleção de Projetos"),
// que usa âncora nativa em vez do <Link> do react-router.
export const NameAnchor = styled.a`
  color: ${({ theme }) => theme.colors.primary.vividCerulean};
  ${linkAppearance}
`;

// Sem id na linha não há destino: mesmo texto, sem âncora.
export const NamePlain = styled.span``;

// Wrapper do ícone da coluna "Ações". O <a> não pode herdar cor nem sublinhado
// de link — o ícone precisa continuar visualmente idêntico ao que já existia.
export const ActionWrapper = styled.div`
  a {
    display: inline-flex;
    color: inherit;
    text-decoration: none;
  }

  svg {
    cursor: pointer;
  }
`;
